/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {InputModule} from '../../../../shared/input/input.module';
import {ActiveInputComponent} from './active-input.component';

@NgModule({
    declarations: [ActiveInputComponent],
    imports: [
        CommonModule,
        InputModule
    ],
    exports: [ActiveInputComponent]
})
export class ActiveInputModule {
}
